import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';

import { AppAlert } from '../alerts.model';
import { AlertService } from '../alerts.service';

@Component({
  selector: 'app-alert-container',
  templateUrl: './alert-container.component.html',
  styleUrls: ['./alert-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertContainerComponent {
  readonly alerts$: Observable<AppAlert[]> = this.alertService.visibleAlerts$;

  constructor(private readonly alertService: AlertService) {}

  dismiss(alertId: number): void {
    this.alertService.dismiss(alertId);
  }

  trackByAlertId(_index: number, alert: AppAlert): number {
    return alert.alertId;
  }
}
